import { resources } from "@/data/content";
import { SectionHeading, Reveal } from "@/components/motion";

export const Resources = () => (
  <section id="resources" className="bg-background py-16 sm:py-24 lg:py-32" data-testid="resources-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="08"
        eyebrow="Patient Resources"
        title="Health Education for Patients"
        sub="Simple, reliable guidance on common health topics. These resources are educational — they do not replace a medical consultation."
      />
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="resources-grid">
        {resources.map((r, i) => (
          <Reveal key={r.title} delay={i % 4}>
            <article
              data-testid={`resource-card-${r.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group h-full bg-white rounded-2xl border border-slate-200/80 shadow-soft p-6 hover:-translate-y-1 hover:shadow-lift hover:border-teal-500/30 transition-[transform,box-shadow,border-color] duration-300"
            >
              <div className="w-10 h-10 rounded-lg bg-teal-50 border border-teal-100 flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300">
                <r.icon size={18} className="text-teal-700 group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="font-serif font-semibold text-slate-900 text-base">{r.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{r.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
